import { cn } from "@/lib/utils";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import StepOne from "./step-one";
import { StepTwo } from "./step-two";

type Step = "step1" | "step2";

interface QuoteFlowProps {
  className?: string;
}

export default function QuoteFlow({ className }: QuoteFlowProps) {
  const [step, setStep] = useState<Step>("step1");
  const navigate = useNavigate();

  const handleFinalStep = (quoteId: string, token: string) => {
    const url = `/cotacao/${quoteId}?token=${encodeURIComponent(token)}`;
    navigate(url);
  };

  return (
    <div
      className={cn(
        "shadow-lg bg-n-bg-2 overflow-hidden rounded-[20px]",
        className,
      )}
    >
      {step === "step1" && <StepOne onNext={() => setStep("step2")} />}
      {step === "step2" && (
        <StepTwo onNext={handleFinalStep} onBack={() => setStep("step1")} />
      )}
    </div>
  );
}
